import { ApiServiceBase } from './ApiServiceBase'
import type { PartnershipApproach } from '~/types'

export default class extends ApiServiceBase {
  async show(company: string, influencer: string) {
    return useAsyncData('partnership-show', () => this.call(`/spa/partnership/${company}/${influencer}`))
  }

  async accept(id: number, data: PartnershipApproach): Promise<void> {
    const hasProofs = data.form.proofs?.is_required

    const formData = objectToFormdata({
      contact: data.form.contact,
      social: data.form.social,
      budgets: data.form.budgets,
      ...(hasProofs && { proofs: data.form.proofs.items }),
    })

    return await this.call(`/spa/partnership/${id}`, {
      method: 'post',
      body: formData,
    })
  }

  async reject(id: number): Promise<void> {
    return await this.call(`/spa/partnership/${id}`, {
      method: 'delete',
    })
  }
}
